import { Component } from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  stagger,
} from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';

@Component({
  selector: 'app-token-login-rfq',
  templateUrl: './tokenLogin-component.html',
  styleUrls: ['./tokenLogin.component.css'],
  animations: [
    trigger('pageFadeUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100vh)' }),
        animate(
          '1200ms cubic-bezier(.22,1,.36,1)',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
    trigger('staggerFadeUp', [
      transition(':enter', [
        query(
          '.stagger-item',
          [
            style({ opacity: 0, transform: 'translateY(13px)' }),
            stagger(80, [
              animate(
                '350ms ease-out',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class TokenLoginComponent {
  securityToken = '';
  loading = false;
  private redirectUrl = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private rfqService: RfqGenerateFormService,
    private rfqTokenAuth: RfqTokenAuthService
  ) {}

  ngOnInit() {
    this.redirectUrl = this.route.snapshot.queryParamMap.get('redirect') || '';
  }

  async verifyToken() {
    const raw = (this.securityToken || '').trim();
    if (!raw) {
      this.snackBar.open('Please enter a valid Security Token', 'Close', {
        duration: 3000,
      });
      return;
    }

    this.loading = true;
    try {
      const data: any = await this.rfqService.verifyRfqToken(raw);
      if (data?.valid) {
        if (data?.rfqAccessToken && data?.rfqId) {
          this.rfqTokenAuth.set(data.rfqAccessToken, data.rfqId, data?.supplierId);
        }
        this.snackBar.open('Token verified successfully', 'Close', {
          duration: 3000,
        });
        if (data?.rfqId) {
          this.router.navigate(['/rfqToken/rfqDetails', data.rfqId]);
        }
      } else {
        // 2026-10-25: an RFQ link now lives at most 30 days (the earlier of the quote-by date and issue + 30 days), so
        // say "expired" when the API says so, as the service RFQ screen does. The API answers 200 here - never a logout.
        const msg = data?.reason === 'expired'
          ? 'This link has expired. Log in to MPS, or ask the buyer to resend the RFQ.'
          : 'Invalid token. Please check and try again.';
        this.snackBar.open(msg, 'Close', {
          duration: 5000,
        });
      }
    } catch (err) {
      this.snackBar.open('Verification failed. Please try again.', 'Close', {
        duration: 3500,
      });
    } finally {
      this.loading = false;
    }
  }
}
